import gql from 'graphql-tag';

export const GameDescriptor = gql`
  fragment GameDescriptor on GameDescriptorV2 {
    json
    __typename
  }
`;
